<template scope="scope">
	<div class="qart">
        <div :id="'qrcode'+contents" class="qrcode" ref="qrcode" :style="{'width':width+'px','height':height+'px'}">
        </div>
        <div class="qrcode_icon">
        	<img :src="icons" alt="" class="icon">
        </div>
    </div>
</template>

<script>
import './qrcode.js';
import $ from 'jquery';

export default {
	props: {
		contents:{
			type: String,
			default: ''
		},
		icons:{
			type: String,
			default: ''
		},
		width:{
			type: Number,
			default: 200
		},
		height:{
			type: Number,
			default: 200
		}
	},
	data: function(){
		
	}
	, ready: function(){
		this._getQart();
	}
	, methods: {
		_getQart: function(){
                // $('.qart').children('img').remove();
                $('.qrcode').remove();
                $('.qrcode_icon').remove();
                if ($('.qart').children('img')){
                    $('.qart').children('img').css('display','none');
                }
                var tDom = this.$el;
                var qrcode = new QRCode(tDom, {
                    width : this.width,//设置宽高
                    height : this.height
                });

                qrcode.makeCode(this.contents);
		}
	}
	, events: {
		
	}
	, watch:{
		contents(){
			this._getQart();
		}
	}
    , destroyed(){
	    debugger
        this.contents ='';
    }
};
</script>

<style lang="scss">
	.qrcode{
		margin: auto;
	}
	.qart{
		position: relative;
	}
    .qart img{
        margin: auto;
    }
	.qrcode_icon{
		position: absolute;
		width: 32px;
		height: 32px;
		top:calc(50% - 18px);
		left:calc(50% - 18px);
	}
	.qrcode_icon .icon{
		width: 100%;
		height: 100%;
	}
</style> 